import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mUSDC.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mUSDC.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  testnetAddress: "0x2dEe9e2ac7c361aB50C5D19111D2B60743C9E9b3",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
